import { Body, Box, Sheet, VStack } from '@hover/blueprint';
import { iBookmark } from '@hover/icons';
import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const AddIdeasToProject = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { setCurrentMenu } = useHomeownerAppContext();
  return (
    <Sheet.Contents header={t('projects.addIdeas.heading')}>
      <VStack alignItems="flex-start">
        <Body color="neutral.600" marginY={0}>
          {t('projects.addIdeas.subHeading')}
        </Body>
        <Box
          paddingBottom={{ tablet: 700 }}
          paddingTop={700}
          width={{ base: '100%', tablet: 'unset' }}
        >
          <Button
            iconAfter={iBookmark}
            onClick={() =>
              setCurrentMenu(HomeownerAppMenuNames.ADD_SAVED_TO_PROJECT)
            }
            size="large"
            sx={{
              svg: { fill: 'current' },
            }}
            variant="tertiary"
            width={{ base: '100%', tablet: undefined }}
          >
            {t('projects.addIdeas.addFromSaved')}
          </Button>
        </Box>
      </VStack>
    </Sheet.Contents>
  );
};

export { AddIdeasToProject };
